import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../Layout';
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Container,
  Flex,
  Radio,
  RadioGroup,
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
  Stack,
  Text,
  useCheckboxGroup,
} from '@chakra-ui/react';
import ProgressPage from '../Progress/ProgressPage';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../Context/AuthContext';
import { getAuthToken } from '../Helpers/script';

const Header = () => {
  return (
    <>
      <Text fontSize="34px" color="#1b254b" fontWeight="700">
        Test Me Mode
      </Text>
      <Flex direction="column" justifyContent="center" alignItems="center">
        <Text
          fontSize={{ base: '1.2rem', md: '2.5rem' }}
          color="#1b254b"
          fontWeight="800"
        >
          Create Your Own
          <span style={{ color: '#4318FF' }}> Quizzes</span>
        </Text>
        <Text align="center" fontSize="0.9rem" color="#718096" fontWeight="500">
          Customize your own quizzes and test your knowledge
        </Text>
      </Flex>
    </>
  );
};

const Body = ({ handleSubmit }) => {
  const [sliderValue, setSliderValue] = useState(5);
  const { value, getCheckboxProps } = useCheckboxGroup({
    defaultValue: ['mcq'],
  });
  const [difficulty, setDifficulty] = useState('easy');
  const { handleConfirmationModal } = useAuth();

  const handleGenerateQuiz = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const notesId = urlParams.get('notesId');
    const course = urlParams.get('course');

    const payload = {
      questions: sliderValue,
      type: value,
      difficulty,
      notesId,
      courseName: course,
    };

    handleSubmit(payload);
  };

  return (
    <Container color="#1B2559">
      <Text fontSize="2rem" m="1rem 0rem">
        Questions
      </Text>
      <Slider
        mt="10"
        defaultValue={5}
        min={1}
        max={25}
        step={1}
        onChange={val => setSliderValue(val)}
        focusThumbOnChange={false}
      >
        <SliderMark
          value={sliderValue}
          textAlign="center"
          //   bg="blue.500"
          bg="#7F56D9"
          color="white"
          mt="-3.3rem"
          ml="-1rem"
          w="8"
          h="8"
          borderRadius="50%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {sliderValue}
        </SliderMark>
        <SliderTrack background="#EAECF0" height="0.5rem">
          <SliderFilledTrack bg="#7F56D9" />
        </SliderTrack>
        <SliderThumb
          height="1.5rem"
          width="1.5rem"
          border="1px solid rgb(127, 86, 217)"
        />
      </Slider>
      {/* <CheckboxGroup colorScheme="green" defaultValue={['mcq']}>
        <Flex direction="column" fontWeight="500" p="1.4rem 0rem">
          <Checkbox value="mcq" {...getCheckboxProps({ value: 'mcq' })}>
            Multiple Choice Questions
          </Checkbox>
          <Checkbox value="frq" {...getCheckboxProps({ value: 'frq' })}>
            Free Response Questions
          </Checkbox>
        </Flex>
      </CheckboxGroup> */}
      <Text fontSize="2rem" m="1rem 0rem">
        Difficulty
      </Text>
      <RadioGroup
        defaultValue={difficulty}
        onChange={val => setDifficulty(val)}
      >
        <Stack
          spacing={{ base: 5, sm: 9 }}
          direction={{ base: 'column', sm: 'row' }}
          pt="1rem"
        >
          <Box
            maxWidth="fit-content"
            p="5px 15px"
            border="1px solid #D0D5DD"
            boxShadow="0px 0px 0px 4px #F2F4F7 ; 0px 1px 2px 0px #1018280D"
            color="#344054"
          >
            <Radio
              value="easy"
              _checked={{ bg: '#7F56D9', borderColor: '#7F56D9' }}
              //   backgroundColor="#7F56D9"
              _before={{ width: '0 !important' }}
            >
              Easy
            </Radio>
          </Box>

          <Box
            maxWidth="fit-content"
            p="5px 15px"
            border="1px solid #D0D5DD"
            boxShadow="0px 0px 0px 4px #F2F4F7 ; 0px 1px 2px 0px #1018280D"
          >
            <Radio
              value="medium"
              _checked={{ bg: '#7F56D9', borderColor: '#7F56D9' }}
              _before={{ width: '0 !important' }}
            >
              Medium
            </Radio>
          </Box>
          <Box
            maxWidth="fit-content"
            p="5px 15px"
            border="1px solid #D0D5DD"
            boxShadow="0px 0px 0px 3px #F2F4F7 ; 0px 1px 2px 0px #1018280D"
          >
            <Radio
              value="hard"
              _checked={{ bg: '#7F56D9', borderColor: '#7F56D9' }}
              _before={{ width: '0 !important' }}
            >
              Hard
            </Radio>
          </Box>
        </Stack>
      </RadioGroup>
      <Flex justifyContent="center">
        <Button
          mt="35px"
          background="linear-gradient(89.2deg, #3D1DFF 9.32%, #6147FF 28.54%, #D451FF 60.81%, #D451FF 63.38%, #EC458D 83.98%)"
          color="#fff"
          _hover={{
            background:
              'linear-gradient(15.46deg, #4A25E1 26.3%, #7B5AFF 86.4%)',
          }}
          // onClick={handleGenerateQuiz}
          onClick={e => handleConfirmationModal(() => handleGenerateQuiz(e), 2)}
        >
          Generate Quiz
        </Button>
      </Flex>
    </Container>
  );
};

const Create = () => {
  const [showConfigure, setShowConfigure] = useState(true);

  const { currentUser, setTopLevelError } = useAuth();
  const history = useHistory();

  const handleGenerateQuiz = useCallback(
    async payload => {
      setShowConfigure(false);

      try {
        const token = await getAuthToken(currentUser);

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL ?? ''}/api/createQuiz`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Handle success response here if necessary

        if (response.status === 200) {
          const { quizID, courseName } = response.data;

          history.push(`/quiz?id=${quizID}&courseName=${courseName}`);
        }
      } catch (err) {
        console.log(err);
        const { status, data } = err?.response ?? {};
        if (status === 401) {
          setTopLevelError('You are not authorized! Please login again.');
        } else {
          if (data?.message) {
            setTopLevelError(err.response.data.message);
          } else {
            setTopLevelError(err.message);
          }
        }

        setShowConfigure(true);
      }
    },
    [currentUser, history, setTopLevelError]
  );

  const renderHeader = useCallback(() => {
    return <Header />;
  }, []);

  const renderConfigureBody = useCallback(() => {
    return <Body handleSubmit={handleGenerateQuiz} />;
  }, [handleGenerateQuiz]);

  return (
    <>
      {showConfigure ? (
        <Layout
          header={renderHeader}
          body={renderConfigureBody}
          hasGenericFooter={true}
        />
      ) : (
        <ProgressPage
          subHeadingText="Generating Quiz"
          dynamicText={[
            'Examining study materials',
            'Crafting your questions',
            'Hold on…Socrates is questioning everything!',
            'Personalizing the quiz',
            'Almost there...',
          ]}
        />
      )}
    </>
  );
};

export default Create;
